interface Props {
  minBuy: number;
  mustBuy: number;
}

export default ({ minBuy, mustBuy }: Props): number => {
  let startQuantity = Math.max(minBuy, mustBuy);

  // handle the case when the start quantity is not divisible by must buy
  if (mustBuy > 1 && minBuy > mustBuy && startQuantity % mustBuy !== 0) {
    let counter = 1;
    while (mustBuy * counter < minBuy) {
      counter += 1;
      startQuantity = mustBuy * counter;
    }
  }

  return startQuantity;
};
